<script module lang="ts">
  export const CONTROL_BAR_BUTTON_TOOLTIP_POSITION = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
  }

  export type ControlBarButtonProps = {
    hidden?: boolean
    id?: string
    color?: string
    hoverColor?: string
    tooltip?: string
    tooltipPosition?: (typeof CONTROL_BAR_BUTTON_TOOLTIP_POSITION)[keyof typeof CONTROL_BAR_BUTTON_TOOLTIP_POSITION]
    hover?: boolean
    onclick?: (e: MouseEvent | KeyboardEvent) => void
    children?: () => any
  }
</script>

<script lang="ts">
  import clsx from 'clsx'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import videoStore from '../../../stores/video.svelte'
  import withPreventDefault from '../../../utils/withPreventDefault'
  import { THEMES } from '../../../const/themes'

  let {
    hidden = false,
    hover = $bindable(false),
    id = '',
    color = undefined,
    hoverColor = undefined,
    tooltip = undefined,
    tooltipPosition = CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
    onclick = undefined,
    children = undefined,
  }: ControlBarButtonProps = $props()

  let finalColor = $state()
  let finalOverColor = $state()

  $effect(() => {
    finalColor =
      color ||
      componentAttributesStore.state.buttonsColor ||
      THEMES.DEFAULT.BUTTONS_COLOR
  })
  $effect(() => {
    finalOverColor =
      hoverColor ||
      componentAttributesStore.state.buttonsHoverColor ||
      componentAttributesStore.state.primaryColor ||
      THEMES.DEFAULT.BUTTONS_HOVER_COLOR ||
      finalColor
  })
</script>

<button
  {id}
  style="fill: {hover ? finalOverColor : finalColor}"
  class={clsx('relative h-full aspect-square', hidden && 'hidden')}
  aria-label={tooltip}
  onclick={(e) => withPreventDefault(e, onclick)}
  onkeydown={(e) =>
    (e.key === 'Enter' || e.key === ' ') && withPreventDefault(e, onclick)}
  onfocus={() => (hover = true)}
  onblur={() => (hover = false)}
  onmouseover={() => (hover = true)}
  onmouseleave={() => (hover = false)}
>
  {#if !videoStore.state.isMobileLayout && tooltip}
    <div
      class={clsx(
        'absolute top-0 z-10 bg-black/60 text-white text-xs px-1 py-0.5 rounded w-fit whitespace-nowrap',
        'opacity-0 transition-opacity duration-200',
        'pointer-events-none',
        'top-[-40px]',
        {
          'opacity-100': hover,
          'left-1/2 -translate-x-1/2':
            tooltipPosition === CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
          'left-0':
            tooltipPosition === CONTROL_BAR_BUTTON_TOOLTIP_POSITION.LEFT,
          'right-0':
            tooltipPosition === CONTROL_BAR_BUTTON_TOOLTIP_POSITION.RIGHT,
        },
      )}
    >
      {tooltip}
    </div>
  {/if}
  {@render children?.()}
</button>
